import { axios } from 'system/axios'

import { OwnProfile, ProfileExtended } from './types/OwnProfile'

export const getOwnProfile = () => axios.get<OwnProfile>('/user/me')

export const getProfileExtended = (id: string) => axios.get<ProfileExtended>(`/profile/${id}/extended`)
